import { render, staticRenderFns } from "./CatalogFiltersTags.vue?vue&type=template&id=04445763&"
import script from "./CatalogFiltersTags.js?vue&type=script&lang=js&"
export * from "./CatalogFiltersTags.js?vue&type=script&lang=js&"
import style0 from "./CatalogFiltersTags.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports